export default __webpack_public_path__ + "static/media/product-2.c77abe14.jpg";